module.exports = __webpack_public_path__ + "img/bg.1e1a94ad.png";